
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pet",
      function () {
        return require("private-next-pages/pet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pet"])
      });
    }
  